import gsap from 'gsap';

const animateTimelineSection1 = (): void => {
    const intro = gsap.timeline({
        delay: 3,
    });

    intro.fromTo('.section-1--title', {
        opacity: 0,
        y: -30,
    }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power3.out',
        stagger: 0.2,
    })

    .fromTo('.section-1--button', {
        opacity: 0,
        y: -30,
    }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power2.out',
        stagger: 0.2,
    }, '-=.7')

    .fromTo('.section-1-bottom-wrapper', {
        yPercent: 75
    }, {
        yPercent: 0,
        duration: 1.55,
        ease: 'power2.out',
    }, '-=1')

    /*
    .fromTo('.section-1--background', {
        opacity: 0,
        y: 75,
    }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power2.out',
        stagger: 0.2,
    }, '-=1')

    .fromTo('.section-1--marquee', {
        opacity: 0,
        y: 75,
        duration: 1,

    }, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: 'power2.out',
        stagger: 0.2,
    }, '-=1')
    */
}

export default animateTimelineSection1;